module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external "extend"
// module id = 3
// module chunks = 0 1 2 3 4